import { CommonModule } from '@angular/common'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { Logger, Options } from 'angular2-logger/core'

import { AttributeModule } from './attribute/attribute.module'
import { AuthGuard } from './auth/guargs/auth.guard'
import { AuthModule } from './auth'
import { AutocompleteModule } from './autocomplete/autocomplete.module'
import { ButtonModule } from './button/button.module'
import { CheckboxComponent } from './checkbox/checkbox.component'
import { ClickOutsideService } from './click-outside/click-outside.service'
import { CommonComponent } from './common.component'
import { DefaultImgModule } from './default-img/default-img.module'
import { ConfirmDialogComponent } from './dialog/confirm-dialog.component'
import { DndModule } from './dnd/dnd.module'
import { FaviconService } from './favicon/favicon.service'
import { HttpModule } from './http/http.module'
import { HttpService } from './http/http.service'
import { ListItemModule } from './list-item/list-item.module'
import { CustomMaterialModule } from './material/custom-material.module'
import { NavbarModule } from './navbar/navbar.module'
import { NotificationService } from './notifications/notification.service'
import { ProfileModule } from './profile/profile.module'
import { SelectModule } from './select/select.module'
import { SignalModule, SignalRService } from './signalR'
import { SoundService } from './sound/sound.service'
import { ConversationTeamsGuard } from './team/guards/conversation-teams.guard'
import { TeamModule } from './team/team.module'
import { TeamsGuard } from './team/guards/teams.guard'
import { TextboxComponent } from './textbox/textbox.component'
import { DurationPipe } from './time/duration.pipe'
import { NiceTimePipe } from './time/nice-time.pipe'
import { TimeService } from './time/time.service'
import { UploadModule } from './upload/upload.module'
import { UserModule } from './user/user.module'
import { ClickOutsideDirective } from './click-outside/click-outside.directive'
import { UtilsModule } from './utils/utils.module'
import { PageTitleNumberService } from './page-title-number/page-title-number.service'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AttributeModule,
    AuthModule.forRoot(),
    AutocompleteModule,
    ButtonModule,
    CustomMaterialModule,
    DndModule.forRoot(),
    HttpModule,
    ListItemModule,
    NavbarModule,
    ProfileModule,
    SelectModule,
    SignalModule,
    TeamModule,
    UploadModule,
    UserModule,
    UtilsModule,
    DefaultImgModule,
  ],
  declarations: [
    NiceTimePipe,
    CheckboxComponent,
    CommonComponent,
    ConfirmDialogComponent,
    DurationPipe,
    NiceTimePipe,
    TextboxComponent,
    ClickOutsideDirective,
  ],
  exports: [
    ReactiveFormsModule,
    AttributeModule,
    AuthModule,
    AutocompleteModule,
    ButtonModule,
    CheckboxComponent,
    CommonComponent,
    ConfirmDialogComponent,
    CustomMaterialModule,
    DndModule,
    DurationPipe,
    HttpModule,
    ListItemModule,
    NavbarModule,
    NiceTimePipe,
    ProfileModule,
    SelectModule,
    NiceTimePipe,
    AuthModule,
    SignalModule,
    TeamModule,
    TextboxComponent,
    UploadModule,
    UserModule,
    UtilsModule,
    DefaultImgModule,
    ClickOutsideDirective,
  ],
  entryComponents: [
    ConfirmDialogComponent
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [ // app wide providers
        Logger,
        Options,
        AuthGuard,
        TimeService,
        NotificationService,
        SoundService,
        FaviconService,
        SignalRService,
        TeamsGuard,
        ConversationTeamsGuard,
        HttpService,
        ClickOutsideService,
        PageTitleNumberService,
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts